//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import ReactGA from "react-ga";
import React from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import ImageCarousel from "./ImageCarousel";
import SocialMediaIcons from "./SocialMediaIcons";
import Zoom from "@material-ui/core/Zoom";
import Grow from "@material-ui/core/Grow";
import Tooltip from "@material-ui/core/Tooltip";

import About from "../About";
import Gallery from "../Gallery";
// import Blogs from "../Blogs";
import swal from "sweetalert";
import BookMe from "../BookMe";
import ContactMe from "../ContactMe";
import { PullToRefresh } from "react-js-pull-to-refresh";
import {
  PullDownContent,
  ReleaseContent,
  RefreshContent,
} from "react-js-pull-to-refresh";
import { architectureURLs } from "../../AllImages/architecture";
import { wallpapersURLs } from "../../AllImages/wallpapers";
import { birdsURLs } from "../../AllImages/birds";
import { compositionURLs } from "../../AllImages/composition";
import { geometryURLs } from "../../AllImages/geometry";
import { landscapeURLs } from "../../AllImages/landscape";
import { manipulationURLs } from "../../AllImages/manipulation";
import { moonURLs } from "../../AllImages/moon";
import { portraitURLs } from "../../AllImages/portrait";
import { streetURLs } from "../../AllImages/street";
import { travelURLs } from "../../AllImages/travel";

//......keep this import at last......
import { useStyles } from "../Styles";
import WhatsappContact from "../WhatsappContact";

function Sidebar() {
  const classes = useStyles();

  const [step, setStep] = React.useState(0);
  const [open, toggleOpen] = React.useState(false);
  const [totalImagesCount, setTotalImagesCount] = React.useState("");

  var onlongtouch;
  var timer;

  React.useEffect(() => {
    // document.oncontextmenu = function (e) {
    //   if (e.button === 2) {
    //     window.alert(
    //       "Hey!! Right click is disabled!"
    //     );
    //     e.preventDefault();
    //     return false;
    //   }
    // };
    // document.ondragstart = function (e) {
    //   window.alert(
    //     "Where you want to drag this image to? Drag feature is disabled!"
    //   );
    //   e.preventDefault();
    //   return false;
    // };

    setTotalImagesCount(
      wallpapersURLs.length +
        landscapeURLs.length +
        manipulationURLs.length +
        geometryURLs.length +
        birdsURLs.length +
        streetURLs.length +
        portraitURLs.length +
        architectureURLs.length +
        travelURLs.length +
        moonURLs.length +
        compositionURLs.length
    );
  }, []);
  // onlongtouch = function () {
  //   timer = null;
  //   window.alert("Hey!! long press is disabled.");
  // };

  const getStepContent = () => {
    switch (step) {
      case 0:
        return <ImageCarousel />;
      case 1:
        return <About />;
      case 2:
        return <Gallery />;
      // case 3:
      //   return <Blogs />;
      case 4:
        return <BookMe />;
      case 5:
        return <ContactMe />;
      case 6:
        return <div />;
      default:
        throw new Error("Unknown step");
    }
  };
  const returnSideBar = () => {
    return (
      <React.Fragment>
        <Zoom in="true">
          <div
            id="sidebar"
            className={!open ? classes.sidebar : classes.sidebarTransition}
          >
            <aside
              className="border js-fullheight"
              style={{
                padding: "1vh",
                marginTop: "inherit",
                fontFamily: "monospace",
                fontSize: "larger",
              }}
            >
              <div className="text-center">
                <a
                  onClick={() => {
                    toggleOpen(false);
                    setStep(0);
                  }}
                >
                  <img
                    id="logo"
                    className={classes.logoimg}
                    src="images/smallest.svg"
                  />
                </a>

                <Grow in="true" style={{ transitionDelay: "500ms" }}>
                  <Tooltip
                    title="Click on my picture to return home"
                    arrow
                    // placement="right"   select b/w top/right/bottom/left-start, top/right/bottom/left, top/right/bottom/left-end
                  >
                    <Typography
                      variant="h5"
                      className={classes.topName}
                      id="nameOnSidebar"
                    >
                      Kushal Verma
                    </Typography>
                  </Tooltip>
                </Grow>
              </div>

              <Typography className={classes.categories}>
                <Link
                  href="#"
                  color="inherit"
                  onClick={(e) => {
                    setStep(1);
                    e.preventDefault();
                    toggleOpen(false);
                  }}
                >
                  About
                </Link>
              </Typography>
              <Typography className={classes.categories}>
                <Link
                  href="#"
                  color="inherit"
                  onClick={(e) => {
                    setStep(2);
                    e.preventDefault();
                    toggleOpen(false);
                  }}
                >
                  Gallery (<small>{totalImagesCount}</small>)
                </Link>
              </Typography>
              <Typography className={classes.categories}>
                <Link
                  href=""
                  color="inherit"
                  onClick={(e) => {
                    // setStep(3);
                    // window.alert("Stay tuned!! will be added soon.");

                    swal({
                      title: "Stay tuned!! it will be added soon :)",
                      icon: "info",
                      button: "OK, I'll wait",
                    });
                    e.preventDefault();
                  }}
                >
                  Blogs
                </Link>
              </Typography>
              <Typography className={classes.categories}>
                <Link
                  href="#"
                  color="inherit"
                  onClick={(e) => {
                    setStep(4);
                    e.preventDefault();
                    toggleOpen(false);
                  }}
                >
                  Book Me
                </Link>
              </Typography>
              <Typography className={classes.categories}>
                <Link
                  href="#"
                  color="inherit"
                  onClick={(e) => {
                    setStep(5);
                    e.preventDefault();
                    toggleOpen(false);
                  }}
                >
                  Contact Me
                </Link>
              </Typography>
              <SocialMediaIcons />
            </aside>
          </div>
        </Zoom>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div id="mainBody">
        <PullToRefresh
          pullDownContent={<PullDownContent />}
          releaseContent={<ReleaseContent />}
          refreshContent={<RefreshContent />}
          pullDownThreshold={100}
          onRefresh={() => window.location.reload()}
          triggerHeight={200}
          backgroundColor="white"
          startInvisible={true}
          backgroundColor="transparent"
        >
          <div id="topForMobile" className={classes.topForMobile}>
            <span
              className={open ? "burger-menuopen" : "burger-menu"}
              onClick={() => {
                toggleOpen(!open);
                let logo = document.getElementById("logo");
                let name = document.getElementById("nameOnSidebar");
                if (open === false) {
                  logo.style.display = "none";
                  name.style.display = "none";
                } else {
                  logo.style.display = "block";
                  name.style.display = "block";
                }
              }}
            >
              <div id="bar1"></div>
              <div id="bar2"></div>
              <div id="bar3"></div>
            </span>
            <span>
              <a
                onClick={() => {
                  setStep(0);
                }}
              >
                {" "}
                <img
                  src="images/smallest.svg"
                  alt=""
                  style={{
                    width: "32%",
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    // position: "relative",
                    borerRadius: "50%",
                    cursor: "pointer",
                  }}
                />
              </a>
              &nbsp;&nbsp;
            </span>
            <span style={{ position: "absolute", marginTop: "1vh" }}>
              <div style={{ width: "100%" }}>
                <Typography variant="caption" style={{ fontSize: "3vw" }}>
                  Hi good people.
                </Typography>
                <Grow in="true">
                  <Tooltip
                    title="Click on my picture to return home"
                    arrow
                    // placement="right"   select b/w top/right/bottom/left-start, top/right/bottom/left, top/right/bottom/left-end
                  >
                    <Typography
                      variant="h5"
                      style={{
                        fontSize: "4vw",
                        fontFamily: "Dancing Script, cursive",
                      }}
                    >
                      I'm Kushal
                    </Typography>
                  </Tooltip>
                </Grow>

                <Typography style={{ fontSize: "3vw" }}>
                  Do explore my world, my photographs via this website.
                </Typography>
                <Typography style={{ fontSize: "3vw" }}>
                  Feel free to share your reviews or ask for queries.
                </Typography>
                <Typography style={{ fontSize: "3vw" }}>
                  Hope you will like my work 😁
                </Typography>
              </div>
            </span>
          </div>

          {returnSideBar()}

          <div id="carouselPart" className={classes.carouselContainer}>
            {getStepContent()}
            <WhatsappContact />

          </div>
        </PullToRefresh>
      </div>
    </React.Fragment>
  );
}

export default Sidebar;

ReactGA.event({
  category: "Homepage",
  action: "Homepage loaded",
});
